import { CanActivateFn, Router } from '@angular/router';
import { CommanSubscribeService } from '../services/comman-subscribe.service';
import { LandingPageService } from '../services/landing-page.service';
import { StorageService } from '../services/storage.service';
import { inject } from '@angular/core';

export const communityGuard: CanActivateFn = (route, state) => {
  let settingsData:any={}
  const router = inject(Router);
  const commanSubscribeService = inject(CommanSubscribeService);
  const landingPageService = inject(LandingPageService);
  const storageService = inject(StorageService);
  settingsData = commanSubscribeService.icWebpageSettingsData
  const userInfo = commanSubscribeService.userInfo;

  const isUserLoggedIn =
    !!userInfo?.access_token &&
    Object.keys(userInfo).length > 0;

  const channelName = route.params['channelName'];
  const pageFrom = state?.root?.queryParams?.['pageFrom'];
  const isPreviewMode = settingsData?.is_preview;
  if (!isUserLoggedIn && !state.url.includes('community/preview') && !pageFrom && !isPreviewMode) {
    // Store the original URL before redirecting
    storageService.setItem('originalReturnUrl', state.url);
    
    // Just open sign-in dialog without redirecting
    landingPageService.openConsumerSignIn({
      channel_name: channelName,
      path: 'community'
    }, Object.keys(settingsData).length > 0 ? '' : 'community');
    return router.createUrlTree([`/${channelName}`]);
  }
  return true;
};
